module.exports = __webpack_public_path__ + "b5c42e450d9d4e31eeaf8113dd73d2b0.ttf";